import { useContext } from 'react';

import { HistogramAnnotationsDataContext } from '../contexts/HistogramAnnotationsData.context.js';

export const useHistogramAnnotationsData = () =>
  useContext(HistogramAnnotationsDataContext);
